var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.storeData.whatsappLink)?_c('v-btn',{staticClass:"whatsapp-button",attrs:{"icon":"","href":_vm.storeData.whatsappLink,"target":"_blank","aria-label":"Chat on WhatsApp"}},[_c('v-icon',{attrs:{"size":"48px","color":"white","role":"img","aria-hidden":"true"}},[_vm._v("mdi-whatsapp")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }